<template>
  <div class="context__form-container">
    <!-- No @input needed: this child form self-registers with the parent
    form (provide/inject in the `form` mixin), so its `source_field_id`
    value and validity are picked up automatically by getFormValues()/
    isFormValid()'s child-form tree-walk. -->
    <SourceFieldSelectSubForm
      :fields="allFieldsInTable"
      :allowed-field-types="allowedSourceFieldTypes"
    />
    <FormGroup
      small-label
      required
      :label="$t('fieldBarcodeSubForm.formatLabel')"
      :error="fieldHasErrors('barcode_format')"
    >
      <Dropdown
        v-model="v$.values.barcode_format.$model"
        :error="fieldHasErrors('barcode_format')"
        :fixed-items="true"
        :show-search="false"
        @hide="v$.values.barcode_format.$touch"
      >
        <DropdownItem
          v-for="format in barcodeFormats"
          :key="format.value"
          :name="format.name"
          :value="format.value"
        ></DropdownItem>
      </Dropdown>
    </FormGroup>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import form from '@baserow/modules/core/mixins/form'
import fieldSubForm from '@baserow/modules/database/mixins/fieldSubForm'
import SourceFieldSelectSubForm from '@baserow/modules/database/components/field/SourceFieldSelectSubForm'
// Same allowed source types as QR Code -- both render whatever text/number
// value the source field currently holds, see BarcodeFieldType (backend).
import { SOURCE_FIELD_REFERENCE_ALLOWED_TYPES } from '@baserow/modules/database/utils/sourceFieldReferenceFieldTypes'

export default {
  name: 'FieldBarcodeSubForm',
  components: { SourceFieldSelectSubForm },
  mixins: [form, fieldSubForm],
  setup() {
    return { v$: useVuelidate({ $lazy: true }) }
  },
  data() {
    return {
      allowedValues: ['barcode_format'],
      values: {
        barcode_format: 'code128',
      },
      allowedSourceFieldTypes: SOURCE_FIELD_REFERENCE_ALLOWED_TYPES,
      barcodeFormats: [
        { value: 'code128', name: 'Code 128' },
        { value: 'ean13', name: 'EAN-13' },
        { value: 'upca', name: 'UPC-A' },
      ],
    }
  },
  validations() {
    return {
      values: {
        barcode_format: { required },
      },
    }
  },
}
</script>
